import { AxiosRequestConfig } from 'axios';
import { NO_CONFIG_URLS } from '../helpers/const';
import { translationRequestMiddleware } from './translation-request';

/**
 * Middleware to handle URL and credentials configuration.
 */
export const urlAndCredentialsMiddleware = (config: AxiosRequestConfig): AxiosRequestConfig => {
  if (NO_CONFIG_URLS.some((v) => config.url?.startsWith(v))) {
    return config;
  }

  let configToModify = { ...config };

  configToModify.withCredentials = true;
  configToModify = translationRequestMiddleware(configToModify);

  if (window?.location?.origin?.endsWith('.io') && window?.APP_CONFIG.VUE_APP_ENV !== 'production') {
    configToModify.baseURL = configToModify.baseURL?.replace('.rentsync.dev', '.rentsync.io');
    configToModify.url = configToModify.url?.replace('.rentsync.dev', '.rentsync.io');
  }

  return configToModify;
};
